import _ from 'lodash';

import { getTranslatedString } from '@skinsoft/ui';

import { Workspace } from "./workspace-data-store";

export const name = (workspace: Workspace, locale: string) => getTranslatedString(_.get(workspace, 'name'), locale);